var _rect, _path, _rect2, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaseManagement = function SvgCaseManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 11,
    x: 13.5,
    y: 5.5,
    stroke: "#FF9D43",
    strokeWidth: 3,
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M8 26a2 2 0 0 0-2 2v25a2 2 0 0 0 2 2h30V37a2 2 0 0 1 2-2h15v-7a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 18,
    x: 3,
    y: 11,
    fill: "#6C9BF1",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 38,
    y: 25,
    fill: "#EEF4FF",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    x: 12,
    y: 25,
    fill: "#EEF4FF",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M38 37a2 2 0 0 1 2-2h23a2 2 0 0 1 2 2v27a2 2 0 0 1-2 2H40a2 2 0 0 1-2-2zm3.5 3a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 0 3H43a1.5 1.5 0 0 1-1.5-1.5m1.5 5.5a1.5 1.5 0 0 0 0 3h14a1.5 1.5 0 0 0 0-3zM41.5 61a1.5 1.5 0 0 1 1.5-1.5h14a1.5 1.5 0 0 1 0 3H43a1.5 1.5 0 0 1-1.5-1.5m1.5-8.5a1.5 1.5 0 0 0 0 3h11a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })));
};
export default SvgCaseManagement;